import { Route, Routes } from "react-router-dom";
import { ROUTER_PATHS } from "@/shared/config/router-paths";
import {
  CartPage,
  ClinicalFecalPage,
  ClinicalSwabsPage,
  ClinicalUrinePage,
  HealthyDonorsPage,
  InfectiousDonorsPage,
  InventoryClientPage,
  MuscleFleshPage,
  OrdersPage,
  ProfilePageCA as ProfilePage,
  ContactUsPageCA as ContactUsPage,
  SpecimenSearchPage,
  NonInventoryClientPage,
  TissueBlocksPage,
} from "@/pages";

export function ClientAreaRouter() {
  const {
    cart,
    clinicalFecal,
    clinicalSwabs,
    clinicalUrine,
    contactUs,
    healthyDonors,
    infectiousDonors,
    inventory,
    muscleFlesh,
    nonInventory,
    orders,
    profile,
    specimenSearch,
    tissueBlocks,
  } = ROUTER_PATHS.clientArea;

  return (
    <Routes>
      <Route path={cart.path} element={<CartPage />} />
      <Route path={clinicalFecal.path} element={<ClinicalFecalPage />} />
      <Route path={clinicalSwabs.path} element={<ClinicalSwabsPage />} />
      <Route path={clinicalUrine.path} element={<ClinicalUrinePage />} />
      <Route path={orders.path} element={<OrdersPage />} />
      <Route path={profile.path} element={<ProfilePage />} />
      <Route path={contactUs.path} element={<ContactUsPage />} />
      <Route path={healthyDonors.path} element={<HealthyDonorsPage />} />
      <Route path={infectiousDonors.path} element={<InfectiousDonorsPage />} />
      <Route path={inventory.path} element={<InventoryClientPage />} />
      <Route path={muscleFlesh.path} element={<MuscleFleshPage />} />
      <Route path={nonInventory.path} element={<NonInventoryClientPage />} />
      <Route path={specimenSearch.path} element={<SpecimenSearchPage />} />
      <Route path={tissueBlocks.path} element={<TissueBlocksPage />} />
    </Routes>
  );
}
